import LegalPage from "@/pages/LegalPage";

export default function Cookies() {
  return (
    <LegalPage
      title="Cookie Policy"
      lastUpdated="December 2025"
      testId="cookies-page"
    >
      <h2 className="font-heading text-3xl uppercase tracking-tight text-white">1. What cookies are</h2>
      <p>
        Cookies are small text files stored on your device when you visit a website. They help
        sites work, remember your preferences, and measure performance.
      </p>

      <h2 className="font-heading text-3xl uppercase tracking-tight text-white">2. Categories we use</h2>
      <ul className="list-disc pl-6 space-y-2">
        <li><strong className="text-white">Essential:</strong> required for the site to function; cannot be switched off.</li>
        <li><strong className="text-white">Analytics:</strong> anonymous usage statistics to help us improve the site.</li>
        <li><strong className="text-white">Marketing:</strong> personalised advertising and remarketing.</li>
      </ul>

      <h2 className="font-heading text-3xl uppercase tracking-tight text-white">3. Your choices</h2>
      <p>
        On your first visit you can choose <em>Accept All</em>, <em>Reject Non-Essential</em>, or
        set preferences for each category. You can reopen the banner at any time by clearing
        your browser storage for this site.
      </p>

      <h2 className="font-heading text-3xl uppercase tracking-tight text-white">4. Third-party services</h2>
      <p>
        Third-party services such as Uber Eats are accessed via external links and set their own
        cookies under their respective policies. We have no control over those cookies.
      </p>

      <h2 className="font-heading text-3xl uppercase tracking-tight text-white">5. Updates</h2>
      <p>
        We may update this Cookie Policy from time to time to reflect changes in technology or
        applicable law. The "last updated" date at the top of this page indicates the latest
        version.
      </p>
    </LegalPage>
  );
}
